import React from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { ChangeExpiredPasswordRequest } from '@openapi';
import 'react-toastify/dist/ReactToastify.css';
import logo from '@assets/images/sage-logo-login.png';
import { toast } from 'react-toastify';
import { AppContext } from '@layouts/AppRouter';
import { Navigation } from '@constants/Navigation';
import './chagePassword.scss';
import styles from './change-auth.module.scss';
import auth from '@services/api/auth';
import { validatePassword } from '@services/utils';
import { ApiError } from '@services/types';

function ChangeExpiredPassword() {
  const [changeForm] = Form.useForm<ChangeExpiredPasswordRequest>();
  const { userId, setUserId, variablesProfile } = React.useContext(AppContext);
  const history = useHistory();

  const handleFinish = async () => {
    const obj = {
      userId: userId || '',
      currentPassword: changeForm.getFieldValue('currentPassword'),
      newPassword: changeForm.getFieldValue('newPassword'),
    };
    try {
      await auth.resetExpiredPass(obj);
      history.push(Navigation.Login);
      setUserId(null);
    } catch (error) {
      if (error instanceof ApiError) {
        toast.error(`${error.error.details}`);
      } else {
        toast.error('Change error', {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };
  return (
    <div className="main-login-page">
      <div className="login-wrapper">
        <img className="login-logo" src={logo} alt="Logo Sagem" />
        <Form className={styles.form} name="normal_login" onFinish={handleFinish} form={changeForm}>
          <Form.Item
            className={styles.block}
            name="currentPassword"
            rules={[
              {
                required: true,
                message: 'Please input your Password!',
              },
            ]}
          >
            <Input
              className={styles.input}
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Current Password"
            />
          </Form.Item>
          <Form.Item
            className={styles.block}
            name="newPassword"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
              () => ({
                validator(_, value) {
                  const passwordError = validatePassword(value, variablesProfile?.minPasswordSize);

                  if (passwordError) {
                    return Promise.reject(new Error(passwordError));
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <Input
              className={styles.input}
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="New Password"
            />
          </Form.Item>
          <Form.Item
            className={styles.block}
            name="confirmPassword"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Please confirm your password!',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('The two passwords that you entered do not match!'));
                },
              }),
            ]}
          >
            <Input
              className={styles.input}
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Repeat Password"
            />
          </Form.Item>
          <Form.Item className="auth-footer">
            <Button className={styles.button} type="primary" htmlType="submit">
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default ChangeExpiredPassword;
